/**
 * MODULE_ORDER – Single source of truth for the permissions matrix ordering.
 * Mirrors the sidebar menu structure exactly.
 *
 * HOW IT WORKS:
 * - The ORDER and GROUPING comes from this file (matches sidebar).
 * - The DATA (permission IDs / checkboxes) comes from the backend API dynamically.
 * - Any module returned by the backend that is NOT listed here will automatically
 *   appear in an "Other" section at the bottom — so nothing is ever silently lost.
 */

export const MODULE_ORDER: { section: string; modules: string[] }[] = [
    {
        section: 'General',
        modules: ['Dashboard', 'Driver', 'Vehicle'],
    },
    {
        section: 'Operations',
        modules: [
            'Maintenance',
            'License Renewal',
            'RC Renewal',
            'Permit Renewal',
            'Insurance Renewal',
            'LPO',
            'Fuel Expense',
            'Accident',
            'Vehicle Sales',
            'Upcoming License Renewal',
            'Upcoming RC Renewal',
            'Upcoming Permit Renewal',
            'Upcoming Insurance Renewal',
            'Upcoming Maintenance',
        ],
    },
    {
        section: 'Reports',
        modules: [
            'Vehicle Report',
            'Branch Report',
            'Expense Report',
            'Renewal Report',
            'Vehicle-Driver Usage Report',
            'Maintenance Report',
            'LPO Report',
            'Permit Report',
            'Insurance Report',
            'RC Report',
            'License Report',
        ],
    },
    {
        section: 'Master Settings',
        modules: [
            'Branch',
            'Service Type',
            'Permit Type',
            'Permit Authority',
            'LPO Type',
            'Inspection Type',
            'Role Management',
            'User Management',
            'General Settings',
        ],
    },
];
